import { UserRole } from '../enums/userRole';

/** Role hierarchy from highest to lowest privilege */
export const ROLE_HIERARCHY = [
  UserRole.SuperAdmin,       // 1
  UserRole.Admin,            // 6
  UserRole.WorkzoneManager,  // 7
  UserRole.ToolManager,      // 2
  UserRole.PromptEditor,      // 8
  UserRole.Viewer,           // 3
];

/**
 * Check if a user's role meets or exceeds the required minimum role.
 * Pending (4) and Blocked (5) are not in the hierarchy and always return false.
 */
export function hasMinRole(userRoleId: number | undefined, requiredRoleId: number): boolean {
  if (userRoleId === undefined) return false;
  const userIndex = ROLE_HIERARCHY.indexOf(userRoleId);
  const requiredIndex = ROLE_HIERARCHY.indexOf(requiredRoleId);
  return userIndex !== -1 && requiredIndex !== -1 && userIndex <= requiredIndex;
}

/**
 * Check if a user's role is at or below the required maximum role (i.e. does NOT exceed it).
 * Pending (4) and Blocked (5) are not in the hierarchy and always return false.
 */
export function hasMaxRole(userRoleId: number | undefined, maxRoleId: number): boolean {
  if (userRoleId === undefined) return false;
  const userIndex = ROLE_HIERARCHY.indexOf(userRoleId);
  const maxIndex = ROLE_HIERARCHY.indexOf(maxRoleId);
  return userIndex !== -1 && maxIndex !== -1 && userIndex >= maxIndex;
}
